import { useState, useEffect, useRef, useContext } from "react";
import React from "react";
import Creatable from "react-select/creatable";
import styles from "../profile/profile.module.css";
import Editor from "utils/Editor";
import { connection } from "utils/apiConnection.ts";
import toast, { Toaster } from "react-hot-toast";
import axios from "axios";
import { useParams } from "react-router";
import BusinessContext from "context/BusinessContext";

const CreateProduct = ({ setLoader, setUpdater, updater }) => {
  const params = useParams();
  const [allProductTags, setAllProductTags] = useState([]);
  const { bpid, setProducts } = useContext(BusinessContext);
  const [localArticleData, setLocalArticleData] = useState({
    title: "",
    shopid: 0,
    description: "",
    score: "",
    cover: null,
    coverId: 0,
    hashtags: [],
    otherFiles: [],
    otherFilesId: [],
  });
  const inputRef = useRef();
  const changeHandler = (type, value) => {
    setLocalArticleData((prev) => {
      return { ...prev, [type]: value };
    });
  };
  const changeHandleraTags = (option) => {
    setLocalArticleData((prev) => {
      let temp = { ...prev };
      temp.hashtags = option;
      return { ...temp };
    });
  };
  async function changeHandlerImg(e) {
    setLocalArticleData({
      ...localArticleData,
      [e.target.name]: e.target.files[0],
    });
    let result = await connection("uploadfiles", {
      "files[]": e.target.files[0],
    });
    console.log("resImg", result);
    setLocalArticleData((prev) => {
      return { ...prev, [e.target.name + "Id"]: result.result[0].id };
    });
  }
  const changeHandlerLogo = (e) => {
    let myFormData = new FormData();
    for (let i = 0; i < e.target.files.length; i++) {
      myFormData.append("files[]", e.target.files[i]);
    }
    axios
      .post("http://tatclub.tatdemo.ir/api/uploadfiles", myFormData)
      .then((res) => {
        setLocalArticleData({
          ...localArticleData,
          otherFiles: e.target.files,
          otherFilesId: res.data.result,
        });
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    async function loadPage() {
      let result = await connection("Find_ProductTags", {});
      // console.log("resaltFind", result);
      let allProductTags = [];
      for (let index = 0; index < result.length; index++) {
        let newObject = {};
        newObject.value = result[index].id;
        newObject.label = result[index].title;
        allProductTags.push(newObject);
      }
      setAllProductTags(allProductTags);
    }
    loadPage();
  }, [updater]);

  async function getProducts() {
    setLoader(true);
    let result = await connection("getproducts", {
      shopSuffix: params.shop_suffix,
    });
    if (result.status == 1) {
      setProducts(result.result);
    }
    setLoader(false);
  }

  async function postHandler() {
    console.log("p");
    let productTags = await Promise.all(
      localArticleData.hashtags.map(async (arrayItem) => {
        console.log("arrayItem", arrayItem);
        let id = arrayItem.value;
        if (arrayItem.__isNew__ == true) {
          let data = await connection("Insert_ProductTags", {
            title: arrayItem.label,
          });
          localArticleData.hashtags.push(data.result.id);
          id = data.result.id;
        } else {
          localArticleData.hashtags.push(+arrayItem.value);
        }
        return id;
      })
    );
    let coverx = localArticleData.coverId;
    let logox = localArticleData.otherFilesId;
    if (localArticleData.coverId === 0) coverx = "";
    if (localArticleData.otherFilesId === undefined)
      localArticleData.otherFilesId = [];
    if (localArticleData.title === "" || coverx === "") {
      toast.error("نام یا کاور محصول را اضافه کنید!");
      return null;
    }
    console.log("e", localArticleData.otherFilesId);
    let result = await connection("addproduct", {
      shopId: bpid,
      description: localArticleData.description,
      title: localArticleData.title,
      tagIds: productTags.join(","),
      sharePoint: localArticleData.score,
      coverImgId: coverx,
      mediaIds: localArticleData.otherFilesId
        .map((value) => value.id)
        .join(","),
    });
    setLocalArticleData({
      title: "",
      description: "",
      score: 0,
      hashtags: [],
      cover: null,
      otherFilesId: [],
    });

    if (result.status == -1) {
      toast.error("خطا در اضافه کردن محصول!");
    } else {
      toast.success("محصول با موفقیت اضافه شد");
    }
    //TODO:
    setUpdater(!updater);
    getProducts();
  }
  return (
    <div
      className="modal fade"
      id="addArticleModal"
      tabIndex={-1}
      aria-labelledby="addArticleModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5> اضافه کردن محصول</h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            />
          </div>
          <div className="modal-body" style={{ backgroundColor: "#f2f0f1" }}>
            <div>
              <form>
                <div className="row">
                  <label for="title" className="col-4">
                    نام محصول
                  </label>
                  <div className="col-8">
                    <input
                      type="text"
                      id="title"
                      className={` ${styles.inputt3} `}
                      value={localArticleData.title}
                      onChange={(e) => {
                        changeHandler("title", e.target.value);
                      }}
                    />
                  </div>
                </div>

                <div className="row mt-3">
                  <div className="col-4">
                    <label for="images">کاور محصول</label>
                  </div>
                  <div className="col-8">
                    <input
                      onChange={changeHandlerImg}
                      type="file"
                      id="images"
                      ref={inputRef}
                      name="cover"
                      className={`${styles.inputt3} `}
                      style={{
                        lineHeight: "35px",
                        paddingRight: "1px",
                      }}
                    />
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-4">
                    <label for="otherFiles">فایل های جانبی </label>
                  </div>
                  <div className="col-8" style={{ height: "40px !important" }}>
                    <input
                      type="file"
                      id="otherFiles"
                      onChange={changeHandlerLogo}
                      ref={inputRef}
                      name="otherFiles"
                      className={` ${styles.inputt3} `}
                      multiple
                      style={{
                        lineHeight: "35px",
                        paddingRight: "1px",
                      }}
                    />
                  </div>
                </div>

                <div className="row mt-3">
                  <div className="col-4">
                    <label for="">امتیاز به ازای اشتراک</label>
                  </div>
                  <div className="col-8">
                    <input
                      type="number"
                      id="score"
                      className={` ${styles.inputt3} `}
                      value={localArticleData.score}
                      onChange={(e) => {
                        changeHandler("score", e.target.value);
                      }}
                    />
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-4">
                    <label for="description">توضیحات</label>
                  </div>
                  <div className="col-8">
                    <Editor
                      setContents={localArticleData.description}
                      onChange={(e) => {
                        changeHandler("description", e);
                      }}
                    />
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-4">
                    <label for="">برچسب</label>
                  </div>
                  <div className="col-8">
                    <Creatable
                      id="tags"
                      options={allProductTags}
                      value={localArticleData.hashtags}
                      onChange={changeHandleraTags}
                      // options={tagsOptions}
                      isMulti={true}
                      className={`mx-1 ${styles.inputt3} `}
                      // value={defaultTags}
                    />
                  </div>
                </div>
              </form>
            </div>
          </div>

          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              بستن
            </button>
            <button
              type="button"
              data-bs-dismiss="modal"
              aria-label="Close"
              className="btn btn-success"
              onClick={() => {
                postHandler(localArticleData);
              }}
            >
              ثبت
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateProduct;
